const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  roles: state => state.user.roles,
  errorLogs: state => state.errorLog.logs,
  windSelectIndex: state => state.windState.windSelectIndex,
  windDataIsShow: state => state.windState.windDataIsShow,
}
export default getters
